<template>
  <vx-card>
    <div id="data-list-list-view">
      <vs-tabs>
        <vs-tab label="我的作品">
          <div class="con-tab-ejemplo">
            <!-- mineWorksSearchSheet -->
            <div class="margin-top">
              <vs-row vs-type="flex">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                    <span>作品名：</span>
                    <vs-input class="inline-block margin" v-model="mineWorksSearchSheet.title"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                    <span>课程：</span>
                    <vs-input class="inline-block margin" v-model="mineWorksSearchSheet.course_name"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                    <span>章节：</span>
                    <vs-input class="inline-block margin" v-model="mineWorksSearchSheet.chapter_name"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                    <span>作品状态</span>
                    <v-select
                      class="inline-block margin width-100"
                      v-model="mineWorksSearchSheet.is_finish"
                      label="name"
                      :options="workStatusList"
                    />
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="flex-end">
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                  <vs-button class="margin" color="primary" type="filled" @click="searchMineWorks">搜索</vs-button>
                  <vs-button class="margin" color="warning" type="border" @click="resetMineWorksSheet">重置</vs-button>
                </vs-col>
              </vs-row>
            </div>
            <!-- mineWorksList -->
            <vs-table stripe ref="mineWorkTable" pagination :max-items="itemsPerPage" :data="workList">
              <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <!-- ITEMS PER PAGE -->
                <vs-dropdown vs-trigger-click class="cursor-pointer mr-4">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ workList.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : workList.length }} of {{ workList.length }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemsPerPage=5">
                      <span>5</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=10">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=15">
                      <span>15</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=20">
                      <span>20</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
              <template slot="thead" class="margin-top">
                <vs-th>序号</vs-th>
                <vs-th>作品名</vs-th>
                <vs-th>课程</vs-th>
                <vs-th>章节</vs-th>
                <vs-th>得分</vs-th>
                <vs-th>作品状态</vs-th>
                <vs-th>完成状态</vs-th>
                <vs-th>更新时间</vs-th>
                <vs-th>操作</vs-th>
              </template>
              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                      <p class="product-name font-medium">{{ indextr + 1 }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.title }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.course_name }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.chapter_name }}</p>
                    </vs-td>
                    <vs-td>
                      <p class="flex items-center"><feather-icon icon="StarIcon" class="color-orange margin-right" svgClasses="fill-current h-4 w-4" /><span>{{ tr.score }}</span></p>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.is_publish?'已发布':'未发布' }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.is_finish?'已完成':'未完成' }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.update_time }}</p>
                    </vs-td>
                    <vs-td>
                      <vs-button class="ml-4" color="warning" size="small" type="filled" @click="openComment(tr)">查看评语</vs-button>
                      <vs-button class="ml-4" color="warning" size="small" type="filled" @click="openScratchWindow(tr.id)">查看作品</vs-button>
                      <vs-button class="ml-4" color="warning" size="small" type="filled" @click="showSharePrompt(tr)">发布并分享</vs-button>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>

    <!-- sharePrompt -->
    <vs-prompt
      vs-title="分享"
      :vs-buttons-hidden="true"
      :vs-active.sync="isShare"
      @vs-close="closeSharePrompt"
    >
      <div class="con-exemple-prompt">
        <div class="flex flex-col items-center my-4">
          <vue-qr :text="qrcodeUrl" :margin="0" colorDark="#f67b29" colorLight="#fff" :logoScale="0.3" :size="200"></vue-qr>
          <p class="margin-top">扫一扫，分享作品</p>
          <!-- <p class="tips">删除后该教师将无法进入HAAI学堂</p> -->
          <div class="mt-3">
            <vs-button color="primary" size="small" type="filled" @click="copyLink">复制连接</vs-button>
            <vs-button class="margin" color="warning" size="small" type="border" @click="closeSharePrompt">取消</vs-button>
          </div>
        </div>
      </div>
    </vs-prompt>
  </vx-card>
</template>

<script>
import { scratchWorkList, publishScratchWork } from '@/api/project'
import vSelect from 'vue-select';
import vueQr from 'vue-qr'
import lodash from 'lodash'
import config from '@/config'

export default {
  components: {
    vSelect,
    vueQr
  },
  data() {
    return {
      workList: [],
      currentPage: 1,
      itemsPerPage: 5,
      isShare: false,
      qrcodeUrl: '',
      workStatusList: [
        {
          id: -1,
          name: '全部'
        },
        {
          id: 1, 
          name: '已完成'
        },
        {
          id: 0,
          name: '未完成'
        }
      ],
      mineWorksSearchSheet: {
        title: '',
        course_name: '',
        chapter_name: '',
        is_finish: {
          id: 0, 
          name: '全部'
        },
      }
    }
  },
  created() {
    
  },
  mounted() {
    this.mineWorksInit();
  },
  methods: {
    mineWorksInit($params = {}) {
      scratchWorkList($params).then(res => {
        if (res.code == 1) {
          this.workList = res.data;
        }
      });
    },
    searchMineWorks() {
      let params = lodash.clone(this.mineWorksSearchSheet);
      params.is_finish = params.is_finish.id
      this.mineWorksInit(params)
    },
    resetMineWorksSheet() {
      this.mineWorksSearchSheet = {
        title: '',
        course_name: '',
        chapter_name: '',
        is_finish: {
          id: 0, 
          name: '全部'
        },
      }
      this.mineWorksInit();
    },
    showSharePrompt(row) {
      if (row.is_finish == 1) {
        this.qrcodeUrl = `${config.shequUrl}/discover/share?id=${row.id}`
        this.isShare = true;
      } else {
        publishScratchWork({
          id: row.id,
          cate_id: 0,
          is_open: 0,
          title: row.title,
          handle_mode: 0
        }).then(res => {
          if (res.code == 1) {
            row.is_finish = 1
            this.qrcodeUrl = `${config.shequUrl}/discover/share?id=${row.id}`
            this.isShare = true;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: '错误',
              text: '分享失败',
              iconPack: 'feather',
              icon: 'icon-check-circle'
            })
          }
        })
      }
      
    },
    closeSharePrompt() {
      this.isShare = false;
    },
    copyLink() {
      const thisIns = this;
      this.$copyText(this.qrcodeUrl).then(function (e) {
        thisIns.$vs.notify({
          title: '成功',
          text: '连接复制成功',
          color: 'success',
          iconPack: 'feather',
          position: 'top-center',
          icon: 'icon-check-circle'
        });
      }, function (e) {
        thisIns.$vs.notify({
          title: '失败',
          text: '复制连接失败，请重试！',
          color: 'danger',
          iconPack: 'feather',
          position: 'top-center',
          icon: 'icon-alert-circle'
        });
      });
    },
    openScratchWindow(id) {
      window.open(`${config.scratchUrl}/?edit#${id}`, 'scratch');
    },
    openComment(row) {
      if (!row.comment) {
        this.$vs.notify({
          color: 'warning',
          text: '老师还没写评语',
          title: '提示',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        })
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `评语`,
          text: row.comment,
          acceptText: '谢谢老师'
        })
      }
      
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  white-space: nowrap;
}
.margin{
  margin: 0 0 0 1rem;
}
.margin-right{
  margin-right: 0.5rem;
}
.margin-top{
  margin-top: 20px;
}
.margin-bottom{
  margin-bottom: 20px;
}
.width-100{
  width: 100%;
}
.vs-col{
  margin-bottom: 20px;
}
.vs-con-input-label{
  width: 100%;
}
.vs-table--content{
  margin-top: 20px;
}
.vs-collapse{
  padding: 10px 0;
}
.flatpickr-input[readonly]{
  width: 100%;
}
.color-orange{
  color: orange;
}
</style>
